<mydocma-app-pane-header [text]="('MM.layout.layout' | translate)"
                         [doneVisible]="false"
                         iconName="view_column"
                         (closeClick)="onCloseClick()"
                         [closeVisible]="!(appContainerService.mobileView$ | async)">

</mydocma-app-pane-header>
<div style="position: relative; height: 100%;">
  <mydocma-loader *ngIf="loading | async" [size]="'small'" class="mydocma-mm-loader"></mydocma-loader>

  <mydocma-tree
    #tree [options]="layoutTreeOptions" [nodeData]="layoutScopes$ | async" class="left-pane-layout-tree"
    [selectedNodeId]="(layoutStateService.currentLayoutState$ | async)?.state?.layout?.Id?.toString()"
    (nodeSelected)="onLayoutClick($event?.data)">
    <div mydocmaTreeToolbarContent>
      <button
        mat-icon-button mydocmaTreeToolbarContent (click)="switchLayoutsFilter()" style="margin-left: 25px">
        <mydocma-custom-mat-icon
          [matTooltip]="'MM.layout.showFavoritesTooltip' | translate"
          class="layout-custom-icon" [iconName]="'_star-filled'"
          *ngIf="(layoutFavoriteFilterMode$ | async) == layoutFavoriteFilterModes.showFavorites"></mydocma-custom-mat-icon>
        <mydocma-custom-mat-icon
          [matTooltip]="'MM.layout.showAllLayouts' | translate"
          class="layout-custom-icon" [iconName]="'_star-half-empty'"
          *ngIf="(layoutFavoriteFilterMode$ | async) == layoutFavoriteFilterModes.showAll"></mydocma-custom-mat-icon>
      </button>
    </div>
    <ng-template mydocmaTreeNodeContent let-tree let-node="node">
      <ng-container class="custom-node-container">
        <div class="node-container-wrapper">
          <ng-container [ngSwitch]="node.data.scope">
            <ng-container *ngSwitchCase="entityScopes.Global">
              <mydocma-custom-mat-icon class="layout-custom-icon" [iconName]="'_globe'"></mydocma-custom-mat-icon>
            </ng-container>
            <ng-container *ngSwitchCase="entityScopes.Project">
              <mydocma-custom-mat-icon class="layout-custom-icon" [iconName]="'_company'"></mydocma-custom-mat-icon>
            </ng-container>
            <ng-container *ngSwitchCase="entityScopes.User">
              <mydocma-custom-mat-icon class="layout-custom-icon" [iconName]="'_user'"></mydocma-custom-mat-icon>
            </ng-container>
            <ng-container *ngSwitchCase="entityScopes.Local">
              <mydocma-custom-mat-icon class="layout-custom-icon" [iconName]="'_local_saved'"></mydocma-custom-mat-icon>
            </ng-container>
          </ng-container>

          <ng-container
            *ngIf="!node.data.scope && (node.data.IsFavoriteAll || node.data.IsFavoriteUser) && (layoutFavoriteFilterMode$ | async) === layoutFavoriteFilterModes.showAll">
            <mydocma-custom-mat-icon class="layout-group-custom-icon"
                                     [iconName]="'_star-filled'"></mydocma-custom-mat-icon>
          </ng-container>
          <ng-container *ngIf="!node.data.scope && !node.data.IsFavoriteAll && !node.data.IsFavoriteUser && (layoutFavoriteFilterMode$ | async) === layoutFavoriteFilterModes.showAll">
            <mydocma-custom-mat-icon class="layout-group-custom-icon" [iconName]="'_star'"></mydocma-custom-mat-icon>
          </ng-container>
          <ng-container *ngIf="!node.data.scope && (layoutFavoriteFilterMode$ | async) === layoutFavoriteFilterModes.showFavorites">
            <div style="width: 8px; min-width: 8px; max-width: 8px"></div>
          </ng-container>
          <!--        test-->
          <span class="node-text" *ngIf="node.data.scope; else child">
            {{(node.text | translate)}} ({{node.filteredChildren?.length}})</span>
          <ng-template #child>
        <span #element class="node-text" [matTooltip]="getTooltipText(node)"
              (mouseenter)="onMouseEnter(element)">
        {{node.text | translate}}
        </span>
            <!--        test-->
          </ng-template>
          <ng-container [ngTemplateOutlet]="(node.data.scope ? menuLayoutGroup : menuLayout)"
                        [ngTemplateOutletContext]="{$implicit: node}"></ng-container>
        </div>
      </ng-container>
    </ng-template>

    <ng-template #menuLayoutGroup let-node="$implicit">
      <button
        #elem
        mat-icon-button
        (menuOpened)="toggleMenu(elem, 'open')"
        (menuClosed)="toggleMenu(elem, 'close')"
        [mydocmaMenuTriggerFor]="tagLayoutGroupMenu" class="layout_moreHoriz"
        (click)="$event.stopPropagation()"

        *ngIf="node.data.scope !== entityScopes.Local && ((scopeSortSetting[node.data.scope] !== 1) || (node.data.scope == entityScopes.User || (node.data.scope == entityScopes.Project && (permissionEditProjectLayout$ | async)) || (node.data.scope == entityScopes.Global && (permissionEditGlobalLayout$ | async))))">
        <mydocma-custom-mat-icon
          [iconName]="'more_horiz'"></mydocma-custom-mat-icon>
      </button>

      <mat-menu #tagLayoutGroupMenu="matMenu">
        <button mat-menu-item (click)="toTopPosition(node)" *ngIf="scopeSortSetting[node.data.scope] !== 1">
          <mydocma-custom-mat-icon [iconName]="'arrow_upward'"></mydocma-custom-mat-icon>
          <span>{{'MM.layout.showFirst' | translate}}</span>
        </button>
        <button mat-menu-item (click)="addLayout(node)"
                *ngIf="node.data.scope == entityScopes.User || (node.data.scope == entityScopes.Project && (permissionEditProjectLayout$ | async)) || (node.data.scope == entityScopes.Global && (permissionEditGlobalLayout$ | async))">
          <mydocma-custom-mat-icon [iconName]="'_plus-math'"></mydocma-custom-mat-icon>
          <span>{{'MM.layout.add' | translate}}</span>
        </button>
      </mat-menu>
    </ng-template>


    <ng-template #menuLayout let-node="$implicit">
      <button
        #elem1
        *ngIf="node.data.Scope !== entityScopes.Local && (isDesktop || (!isDesktop && currentSelectedLayoutId == node.data.Id))"
        (menuOpened)="toggleMenu(elem1, 'open')"
        (menuClosed)="toggleMenu(elem1, 'close')"
        mat-icon-button [mydocmaMenuTriggerFor]="tagLayoutMenu" class="layout_moreHoriz"
        (click)="$event.stopPropagation()">
        <mydocma-custom-mat-icon
          [iconName]="'more_horiz'">
        </mydocma-custom-mat-icon>
      </button>

      <mat-menu #tagLayoutMenu="matMenu">
        <button mat-menu-item (click)="editLayout(node)"
                *ngIf="node.data.Scope == entityScopes.User || (node.data.Scope == entityScopes.Project && (permissionEditProjectLayout$ | async)) || (node.data.Scope == entityScopes.Global && (permissionEditGlobalLayout$ | async))">
          <mydocma-custom-mat-icon
            fontSet="material-icons-outlined"
            [iconName]="'edit'"></mydocma-custom-mat-icon>
          <span>{{'MM.layout.edit' | translate}}</span>
        </button>
        <button mat-menu-item
                (click)="layoutEditService.setFavorite(node.data, currentProject, !node.data.IsFavoriteUser, '/IsFavoriteUser')">
          <mydocma-custom-mat-icon [iconName]="'_FavoritMe_Remove'"
                                   *ngIf="node.data.IsFavoriteUser"></mydocma-custom-mat-icon>
          <mydocma-custom-mat-icon [iconName]="'_FavoritMe_Add'"
                                   *ngIf="!node.data.IsFavoriteUser"></mydocma-custom-mat-icon>
          <span *ngIf="node.data.IsFavoriteUser">{{'MM.layout.favoriteUserRemove' | translate}}</span>
          <span *ngIf="!node.data.IsFavoriteUser">{{'MM.layout.favoriteUser' | translate}}</span>
        </button>
        <button mat-menu-item
                (click)="layoutEditService.setFavorite(node.data, currentProject, !node.data.IsFavoriteAll, '/IsFavoriteAll')"
                *ngIf="node.data.Scope != entityScopes.User && ((node.data.Scope == entityScopes.Project && (permissionEditProjectLayout$ | async)) || (node.data.Scope == entityScopes.Global && (permissionEditGlobalLayout$ | async)))">
          <mydocma-custom-mat-icon [iconName]="'_FavoritAll_Remove'"
                                   *ngIf="node.data.IsFavoriteAll"></mydocma-custom-mat-icon>
          <mydocma-custom-mat-icon [iconName]="'_FavoritAll_Add'"
                                   *ngIf="!node.data.IsFavoriteAll"></mydocma-custom-mat-icon>
          <span *ngIf="node.data.IsFavoriteAll">{{'MM.layout.favoriteAllRemove' | translate}}</span>
          <span *ngIf="!node.data.IsFavoriteAll">{{'MM.layout.favoriteAll' | translate}}</span>
        </button>
        <!--suppress TypeScriptValidateTypes -->
        <button mat-menu-item (click)="saveForAll(node)"
                *ngIf="((layoutEditService.layoutStates$ | async).hasOwnProperty(node.data.SUid) && (layoutEditService.layoutStates$ | async)[node.data.SUid] === true) && ((node.data.Scope == entityScopes.Project && (permissionEditProjectLayout$ | async)) || (node.data.Scope == entityScopes.Global && (permissionEditGlobalLayout$ | async)))">
          <mydocma-custom-mat-icon
            fontSet="material-icons-outlined"
            [iconName]="'save'"></mydocma-custom-mat-icon>
          <span>{{'MM.layout.saveForAll' | translate}}</span>
        </button>
        <!--suppress TypeScriptValidateTypes -->
        <button mat-menu-item (click)="revert(node)"
                *ngIf="((layoutEditService.layoutStates$ | async).hasOwnProperty(node.data.SUid) && (layoutEditService.layoutStates$ | async)[node.data.SUid] === true)">
          <mydocma-custom-mat-icon [iconName]="'_rotate'"></mydocma-custom-mat-icon>
          <span>{{'MM.layout.reset' | translate}}</span>
        </button>
        <button mat-menu-item (click)="duplicateLayout(node)">
          <mydocma-custom-mat-icon [iconName]="'content_copy'"></mydocma-custom-mat-icon>
          <span>{{'MM.layout.duplicate' | translate}}</span>
        </button>
        <button mat-menu-item (click)="deleteLayout(node)"
                *ngIf="(layoutStateService.currentLayoutState$ | async)?.state.layout?.Id !== node.data.Id && (node.data.Scope == entityScopes.User || (node.data.Scope == entityScopes.Project && (permissionEditProjectLayout$ | async)) || (node.data.Scope == entityScopes.Global && (permissionEditGlobalLayout$ | async)))">
          <mydocma-custom-mat-icon
            fontSet="material-icons-outlined"
            [iconName]="'delete'"></mydocma-custom-mat-icon>
          <span>{{'MM.layout.delete' | translate}}</span>
        </button>
      </mat-menu>
    </ng-template>


  </mydocma-tree>
</div>
<div class="mobile-pane-footer" *ngIf="(appContainerService.mobileView$ | async)">
  <div style="margin-right: 10px">
    <button mat-stroked-button (click)="onCloseClick()" class="mydocma-btn-primary">
      {{'Ok'}}
    </button>
  </div>
</div>
